// extracted by mini-css-extract-plugin
export default {"backLink":"BackLink_backLink__tO0rw","backLinkTitle":"BackLink_backLinkTitle__ezXzv"};